import React, { FC } from 'react';
import { OrangeWarningIcon } from 'src/components/Icons';
import { ToggleSwitch } from 'src/components/ToggleSwitch';
import { StripeBaseBox } from '../../StripeBaseBox';
import { PaymentMethod, useCTAHandler } from '../../../useCTAHandler';
import { usePaymentOnboardModal } from 'src/payments/hooks/usePaymentsOnboardModal';
import { PaymentsEnablingModal } from 'src/payments/components/PaymentsModals/PaymentsEnablingModal';
import injectStore from 'src/util/injectStore';
import { AppStore } from 'src/stores/AppStore';
import { PaymentEventActivePaymentProvider, PaymentEventComponent } from 'src/payments/types';
import { getPaymentEventSource } from 'src/payments/utils';
import { useTrackPaymentsViewedEvent } from 'src/payments/hooks/useTrackPaymentsViewedEvent';

const StripeGlobalPaymentToggleBoxComponent: FC<
  {
    checked: boolean;
    activatePayments: (enable: boolean) => Promise<void>;
  } & { store: AppStore }
> = ({ checked, activatePayments, store: { user } }) => {
  const stripeSharedMetadata = {
    activePaymentProvider: PaymentEventActivePaymentProvider.STRIPE,
    source: getPaymentEventSource()
  };
  const { isOpen, showModal, hideModal } = usePaymentOnboardModal();
  const { handleAcceptingClick, loading } = useCTAHandler(PaymentMethod.Stripe);

  const onClickHandler = () => {
    user.events.trackAction('payments-cta', {
      ...stripeSharedMetadata,
      component: PaymentEventComponent.modalEnabling
    });
    handleAcceptingClick(!checked, activatePayments);
  };

  const onHideModal = () => {
    user.events.trackAction('payments-cta', {
      ...stripeSharedMetadata,
      component: PaymentEventComponent.modalEnablingClose
    });
    hideModal();
  };

  useTrackPaymentsViewedEvent(
    { ...stripeSharedMetadata, component: PaymentEventComponent.tileGlobalDisabled },
    user.events
  );

  return (
    <div data-testid="stripeGlobalPaymentToggleBox">
      <StripeBaseBox
        icon={<OrangeWarningIcon />}
        actionElement={
          <div className="w-auto max-w-[30%] flex items-center justify-center">
            <ToggleSwitch checked={checked} onChange={showModal} disabled={loading} />
          </div>
        }
      />
      <PaymentsEnablingModal
        activePaymentProvider={PaymentEventActivePaymentProvider.STRIPE}
        isOpen={isOpen}
        hideModal={onHideModal}
        onClickHandler={onClickHandler}
      />
    </div>
  );
};

export const StripeGlobalPaymentToggleBox = injectStore(StripeGlobalPaymentToggleBoxComponent);
